import { PaletteOptions } from "@mui/material/styles";
import * as lightTokens from "./tokens";

export const palette: PaletteOptions = {
  mode: "light",
  background: {
    default: lightTokens.defaultBackground,
    paper: lightTokens.paperBackground,
    light: lightTokens.lightBackground,
    lighter: lightTokens.lighterBackground,
    lightest: lightTokens.lightestBackground,
  },
  text: {
    primary: lightTokens.primaryText,
    secondary: lightTokens.secondaryText,
    disabled: lightTokens.disabledText,
    warning: lightTokens.warningText,
  },
  code: {
    background: lightTokens.codeBackgroundColor,
    flash: lightTokens.codeFlash,
  },
  tables: {
    tableHead: {
      shadow: lightTokens.tableHeadShadow,
    },
    tableCell: {
      borderBottom: lightTokens.tableBorder,
    },
  },
  tooltip: {
    background: lightTokens.tooltipBackground,
    shadow: lightTokens.tooltipShadow,
    arrowShadow: lightTokens.tooltipArrowShadow,
  },
};
